.map-container {
    border:1px solid hsl(0, 0%, 80%);
}